import { Component, Input, OnInit } from '@angular/core';
import { OCC_USER_ID_CURRENT, Product, UserIdService } from '@spartacus/core';
import { BehaviorSubject, map, take } from 'rxjs';
import { ProductInventoryService } from './core/product-inventory.service';
import { WarehousesRequest, Warehouse } from './core/product-inventory.model';
import { initialStatus, loadingStatus } from '../../../../core/models/request-status.model';
import { Alert, ALERT_TYPE } from '../../../../components/alert/alert.model';
import { ProductCheckInventoryService } from './product-check-inventory.service';
import { ModalService } from '../../../../components/modal-list/modal-list.service';

@Component({
  selector: 'product-inventory',
  templateUrl: './product-inventory.component.html',
  styleUrl: './product-inventory.component.scss',
  standalone: false,
})
export class ProductInventoryComponent implements OnInit {
  @Input() data!: {
    product: Product;
    currentWarehouse: Warehouse;
    hasRadioOptions: boolean;
    selectWarehouse: Function;
    onChangeWarehouse: Function;
    requestShippingDate: string;
  };

  product!: Product;
  requestShippingDate: string = '';
  isLogged$ = this.userIdService.getUserId().pipe(map(userID => userID === OCC_USER_ID_CURRENT));
  warehouses$ = new BehaviorSubject<Warehouse[]>([]);
  currentWarehouse?: Warehouse;
  requestCheckInventory$ = new BehaviorSubject<WarehousesRequest>({ ...initialStatus });
  errorMessage: Alert = {
    isActive: true,
    content: '',
    type: ALERT_TYPE.DANGER,
    hasCloseButton: false,
  };

  constructor(
    private userIdService: UserIdService,
    private productInventoryService: ProductInventoryService,
    private productCheckInventoryService: ProductCheckInventoryService,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.populateComponent();
  }

  populateComponent() {
    this.currentWarehouse = this.data.currentWarehouse;
    this.product = this.data.product;
    this.requestShippingDate = this.data.requestShippingDate;
    this.requestCheckInventory$.next({ ...loadingStatus });

    this.product &&
      this.productInventoryService
        .fetch(this.product.code!, this.requestShippingDate)
        .pipe(take(1))
        .subscribe(reponse => {
          const warehouses = reponse.warehouses || [];

          if (reponse.hasError && reponse.message) {
            this.errorMessage.content = reponse.message;
          }

          this.requestCheckInventory$.next(reponse);
          this.warehouses$.next(warehouses);
        });
  }

  close() {
    this.modalService.close();
  }

  select() {
    if (this.data.selectWarehouse) {
      this.data.selectWarehouse(this.currentWarehouse);
    } else {
      this.productCheckInventoryService.setWarehouse(this.currentWarehouse);
    }

    this.close();
  }

  selectWarehouse(warehouse: Warehouse) {
    this.currentWarehouse = warehouse;
    this.data.onChangeWarehouse && this.data.onChangeWarehouse(warehouse);
  }
}
